import styled from 'styled-components';

interface BreadcrumbsProps {
  separator?: string;
}

interface BreadcrumbItemProps {
  active?: boolean;
  clickable?: boolean;
}

export const BreadcrumbsContainer = styled.nav<BreadcrumbsProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1rem;
`;

export const BreadcrumbItem = styled.span<BreadcrumbItemProps>`
  color: ${props => props.active ? '#374151' : '#6b7280'};
  font-weight: ${props => props.active ? '600' : '400'};
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
  transition: color 0.2s ease;

  ${props => props.clickable && !props.active && `
    &:hover {
      color: #667eea;
      text-decoration: underline;
    }
  `}
`;

export const BreadcrumbSeparator = styled.span`
  color: #d1d5db;
  user-select: none;
  
  &::before {
    content: '/';
  }
`;